import { AccountCardMenuItem, CopyHashMenuItem } from '@make-software/csprclick-ui';

export const accountMenuItems = [<AccountCardMenuItem key={0} />, <CopyHashMenuItem key={1} />];
